export default "__VITE_ASSET__ErXLAWd$__"